<template>
  <div ref="scrollRef" class="infiniteScroll" @scroll="onScroll">
    <slot></slot>
    <EmptyView v-if="empty && status === 'noData'">
      <template #content>
        {{ emptyText }}
      </template>
    </EmptyView>
    <div class="h-[50px] flex-center">
      <div
        v-if="!['noMore', 'noData'].includes(status)"
        ref="loadingRef"
        v-intersect="handleInView"
        class="text-center"
      >
        <a-spin :spinning="status === 'loading'" />
      </div>
      <Divider v-if="status === 'noMore'"> </Divider>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { debounce, throttle } from 'lodash-es';

interface InfiniteScrollProps {
  status: 'loading' | 'loadComplete' | 'noMore' | 'noData'; // 正在加载，加载完成，没有更多
  emptyText?: string;
  empty?: boolean;
  noMoreText?: string;
}

const props = withDefaults(defineProps<InfiniteScrollProps>(), {
  empty: true,
});

const scrollRef = ref<HTMLElement>();
const loadingRef = ref<HTMLElement>();

const emit = defineEmits(['scroll', 'loadMore']);

function onScroll(e: Event) {
  if (props.status === 'loading') {
    return;
  }

  emit('scroll', e);
}

const loadMore = throttle(() => emit('loadMore'), 500);

function handleInView(inView: boolean) {
  if (inView) {
    // emit('loadMore')
    loadMore();
  }
}

defineExpose({
  scrollTop(location: number) {
    (scrollRef.value as HTMLElement).scrollTo({
      top: location,
      behavior: 'smooth',
    });
  },
});

function isElementInViewport(element: HTMLElement) {
  if (!element) {
    return false;
  }

  const rect = element.getBoundingClientRect();

  // 判断元素是否在视口范围内
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

watch(
  () => props.status,
  (val, oldVal) => {
    if (oldVal === 'loading' && val === 'loadComplete') {
      // loadingRef.value?.scrollIntoView()
      nextTick(() => {
        if (loadingRef.value && isElementInViewport(loadingRef.value as HTMLElement)) {
          emit('loadMore');
        }
      });
    }
  },
);
</script>
<style lang="scss" scoped>
.infiniteScroll {
  height: 100%;
  overflow-y: scroll;
}

.emptyArea {
  @apply relative top-1/2 -translate-y-1/2;
}
</style>
